<div class="col-md-12 p-0 mt-2" *ngIf="userIsLoading === false">
  <ng-container *ngIf="!showUserNews; else doShowUserNews">
    <app-my-teams-page [styleMode]="'withoutHeading'" [hasMargin]="true"></app-my-teams-page>
  </ng-container>

  <ng-template #doShowUserNews>
    <app-desktop-reporter-news-card [onHomeNewsPage]="true"></app-desktop-reporter-news-card>

    <app-news-list [newsEntries]="userNewsEntries" [sponsors]="[]"></app-news-list>

    <div class="spinner-container" *ngIf="loading">
      <mat-spinner strokeWidth="2" color="primary" diameter="54" class="m-auto"></mat-spinner>
    </div>

    <div class="col-md-12 p-0 text-center" *ngIf="loading === false && userNewsEntries.length === 0">
      <p>Keine News vorhanden</p>
    </div>

    <button *ngIf="loading === false && moreUserNewsEntriesAvailable" mat-raised-button class="news-load-more" (click)="loadMoreUserNews()">
      Weitere Einträge laden
    </button>
  </ng-template>
</div>

<div class="col-md-12 p-0 mt-2" *ngIf="userIsLoading === true">
  <div class="spinner-container">
    <mat-spinner strokeWidth="2" color="primary" diameter="54" class="m-auto"></mat-spinner>
  </div>
</div>
